<template>
  <div id="exportar-bpa">
    <Menu />
    <div class="container main">
      <div class="row">
        <div class="col-md-12">
          <SectionTitle
            title="Exportar BPA"
            description="Dados do Órgão Responsável pela Informação"
            url="/bpa-e-ras"
            :enabledModalInformacao="true"
            :enabledIframeModalInformacao="true"
            urlIframeModalInformacao="https://doc.clickup.com/9011510980/d/h/8cj1fp4-1631/599ea88448ce3d9/8cj1fp4-4371"
            pageIdentifier="exportar-bpa"
          />
        </div>
      </div>
      <ValidationObserver ref="form">
        <div class="row mb-3 container-inputs">
          <div class="col-md-12">
            <fieldset class="bpa-fieldset">
              <legend class="bpa-fieldset__legend">
                Órgão Responsável pela Informação
              </legend>

              <div class="row">
                <div class="col-md-5">
                  <validation-provider v-slot="{ errors }" rules="required">
                    <label for="">Nome</label>
                    <input
                      type="text"
                      class="form-control"
                      v-model="form.rspNome"
                    />
                    <div class="error">{{ errors[0] }}</div>
                  </validation-provider>
                </div>

                <div class="col-md-2 col-12">
                  <validation-provider v-slot="{ errors }" rules="required">
                    <label for="">UF</label>
                    <vue-select
                      :options="estados"
                      label="uf"
                      placeholder=""
                      @input="onChangeEstados"
                      v-model="form.estado"
                      class="vue-select-estado"
                    >
                      <div slot="no-options">Não há opções correspondentes</div>
                    </vue-select>
                    <div class="error">{{ errors[0] }}</div>
                  </validation-provider>
                </div>

                <div class="col-md-5 col-12">
                  <validation-provider v-slot="{ errors }" rules="required">
                    <label for="">Município</label>
                    <vue-select
                      :options="cidades"
                      label="no_municipio"
                      placeholder=""
                      v-model="form.cidade"
                      :loading="loadingSelectCidades"
                      :disabled="loadingSelectCidades"
                    >
                      <template slot="option" slot-scope="option">
                        {{ option.no_municipio }}
                      </template>
                      <div slot="no-options">Não há opções correspondentes</div>
                    </vue-select>
                    <div class="error">{{ errors[0] }}</div>
                  </validation-provider>
                </div>

                <div class="col-md-3">
                  <validation-provider v-slot="{ errors }" rules="">
                    <label for="">Sigla</label>
                    <input
                      type="text"
                      class="form-control"
                      v-model="form.rspSigla"
                    />
                    <div class="error">{{ errors[0] }}</div>
                  </validation-provider>
                </div>

                <div class="col-md-4">
                  <validation-provider v-slot="{ errors }" rules="cnpj">
                    <label for="">CNPJ</label>
                    <input
                      type="text"
                      class="form-control"
                      v-model="form.rspCgcCpf"
                      v-inputmask="maskCnpj"
                    />
                    <div class="error">{{ errors[0] }}</div>
                  </validation-provider>
                </div>
              </div>
            </fieldset>
          </div>

          <div class="col-md-12">
            <fieldset class="bpa-fieldset">
              <legend class="bpa-fieldset__legend">
                Secretaria de saúde de destino do(s) B.P.A(s)
              </legend>
              <div class="row">
                <div class="col-md-5">
                  <validation-provider v-slot="{ errors }" rules="">
                    <label for="">Nome</label>
                    <input
                      type="text"
                      class="form-control"
                      v-model="form.destinoNome"
                    />
                    <div class="error">{{ errors[0] }}</div>
                  </validation-provider>
                </div>
                <div class="col-md-3">
                  <validation-provider v-slot="{ errors }" rules="required">
                    <label for="">Órgão destino</label>

                    <div class="d-flex align-items-center flex-wrap gap-2">
                      <b-form-radio v-model="form.destinoTipo" value="M" inline>
                        Municipal
                      </b-form-radio>

                      <b-form-radio v-model="form.destinoTipo" value="E" inline>
                        Estadual
                      </b-form-radio>
                    </div>

                    <div class="error">{{ errors[0] }}</div>
                  </validation-provider>
                </div>
              </div>
            </fieldset>
          </div>

          <div class="col-md-3">
            <validation-provider v-slot="{ errors }" rules="required">
              <label for="">Versão do sistema BPA</label>
              <input
                type="text"
                class="form-control"
                v-model="form.versao"
                maxlength="10"
                placeholder=""
              />
              <div class="error">{{ errors[0] }}</div>
            </validation-provider>
          </div>
          <div class="col-md-3">
            <validation-provider v-slot="{ errors }" rules="required">
              <label for="">Mês</label>
              <vue-select
                :options="monthOptions"
                label="label"
                placeholder=""
                v-model="form.mes"
                :clearable="false"
              >
                <template slot="option" slot-scope="option">
                  {{ option.label }}
                </template>
                <div slot="no-options">Não há opções correspondentes</div>
              </vue-select>
              <div class="error">{{ errors[0] }}</div>
            </validation-provider>
          </div>
          <div class="col-md-3">
            <validation-provider
              v-slot="{ errors }"
              rules="required|onlyNumbers|ano"
            >
              <label for="">Ano</label>
              <input
                type="text"
                class="form-control"
                placeholder=""
                v-model="form.ano"
                v-inputmask="maskNumbers"
                maxlength="4"
              />
              <div class="error">{{ errors[0] }}</div>
            </validation-provider>
          </div>

          <div class="col-md-12">
            <validation-provider v-slot="{ errors }" rules="required">
              <!-- Header -->
              <!-- <div class="tipo-export__header">
                <div class="tipo-export__title">
                  Procedimentos compatíveis com BPA-I e BPA-C
                </div>
              </div> -->

              <!-- Info box -->
              <div class="tipo-export__info">
                <div class="tipo-export__info-title">
                  Procedimentos exportáveis como BPA-I ou BPA-C
                </div>
                <div class="tipo-export__info-text">
                  <p>
                    Os procedimentos que podem ser exportados tanto no
                    <b> BPA-I</b> quanto no <b>BPA-C</b> não podem ser incluídos
                    em ambos os arquivos simultaneamente. Por padrão, caso
                    nenhuma alteração seja feita, o sistema os exportará no
                    <b>BPA-C</b>. Por favor, informe como deseja proceder com a
                    exportação.
                  </p>
                </div>
                <!-- Options -->
                <b-form-radio-group
                  v-model="form.tipo"
                  name="tipo-exportacao"
                  class="tipo-export__group"
                >
                  <label
                    v-for="opt in typeOptions"
                    :key="opt.value"
                    class="tipo-export__option"
                    :class="{ 'is-active': form.tipo === opt.value }"
                  >
                    <b-form-radio
                      class="tipo-export__radio"
                      :value="opt.value"
                    />

                    <div class="tipo-export__option-content">
                      <div class="tipo-export__option-title">
                        {{ opt.label }}
                      </div>
                      <div class="tipo-export__option-desc">
                        {{ opt.description }}
                      </div>
                    </div>
                  </label>
                </b-form-radio-group>
              </div>

              <div class="error">{{ errors[0] }}</div>
            </validation-provider>
          </div>

          <div class="col-md-6">
            <validation-provider v-slot="{ errors }" rules="required">
              <label for="">Unidade de saúde</label>
              <vue-select
                :options="estabelecimentos"
                label="no_unidade_saude"
                placeholder=""
                v-model="form.co_ubs"
                :loading="loadingSelectEstabelecimento"
              >
                <template slot="option" slot-scope="option">
                  {{ option.no_unidade_saude }}
                </template>
                <div slot="no-options">Não há opções correspondentes</div>
              </vue-select>
              <div class="error">{{ errors[0] }}</div>
            </validation-provider>
          </div>

          <div class="col-md-12">
            <div
              class="d-flex justify-content-start btn-actions"
              style="gap: 10px"
            >
              <button
                v-if="sigtapObrigatorio"
                class="btn btn-secondary"
                :disabled="loadingImportarSigtap"
                @click="$refs.modalImportarSigtap.abrir()"
              >
                <span
                  v-if="loadingImportarSigtap"
                  class="spinner-border spinner-border-sm me-2"
                ></span>

                {{
                  loadingImportarSigtap ? 'Importando...' : 'Importar SIGTAP'
                }}
              </button>

              <button
                class="btn btn-primary"
                :disabled="loading || !exportacaoLiberada"
                @click="exportar"
              >
                <span
                  v-if="loading"
                  class="spinner-border spinner-border-sm me-2"
                ></span>

                {{ loading ? 'Exportando...' : 'Exportar BPA' }}
              </button>
            </div>

            <small
              v-if="sigtapObrigatorio && !exportacaoLiberada"
              class="text-muted d-block mt-2"
            >
              Importe o SIGTAP antes de exportar.
            </small>
          </div>
        </div>
      </ValidationObserver>
    </div>

    <ModalImportarSigtap
      ref="modalImportarSigtap"
      :loading="loadingImportarSigtap"
      @importar="importarSigtap"
    />
    <Footer />
  </div>
</template>

<script>
import Menu from '@/components/Menu'
import Footer from '@/components/Footer'
import SectionTitle from '@/components/SectionTitle'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import { validations } from '@/mixins/validations'
validations()
import Masks from '@/mixins/masks'
import { MAP_TIPO_LOGRADOURO, normalizeTexto } from './utils.js'
import ModalImportarSigtap from './components/ModalImportarSigtap.vue'

export default {
  name: 'ExportarBpa',
  components: {
    Menu,
    Footer,
    SectionTitle,
    ValidationObserver,
    ValidationProvider,
    ModalImportarSigtap,
  },
  data() {
    return {
      estados: [
        { uf: 'AC' },
        { uf: 'AL' },
        { uf: 'AP' },
        { uf: 'AM' },
        { uf: 'BA' },
        { uf: 'CE' },
        { uf: 'DF' },
        { uf: 'ES' },
        { uf: 'GO' },
        { uf: 'MA' },
        { uf: 'MT' },
        { uf: 'MS' },
        { uf: 'MG' },
        { uf: 'PA' },
        { uf: 'PB' },
        { uf: 'PR' },
        { uf: 'PE' },
        { uf: 'PI' },
        { uf: 'RJ' },
        { uf: 'RN' },
        { uf: 'RS' },
        { uf: 'RO' },
        { uf: 'RR' },
        { uf: 'SC' },
        { uf: 'SP' },
        { uf: 'SE' },
        { uf: 'TO' },
      ],
      cidades: [],
      monthOptions: [
        { label: 'Janeiro', value: '01' },
        { label: 'Fevereiro', value: '02' },
        { label: 'Março', value: '03' },
        { label: 'Abril', value: '04' },
        { label: 'Maio', value: '05' },
        { label: 'Junho', value: '06' },
        { label: 'Julho', value: '07' },
        { label: 'Agosto', value: '08' },
        { label: 'Setembro', value: '09' },
        { label: 'Outubro', value: '10' },
        { label: 'Novembro', value: '11' },
        { label: 'Dezembro', value: '12' },
      ],
      form: {
        estado: '',
        cidade: '',
        rspNome: '',
        rspSigla: '',
        rspCgcCpf: '',
        destinoNome: '',
        destinoTipo: 'M', // 'M' ou 'E'
        versao: '',
        mes: null,
        ano: '',
        tipo: 'bpac',
        co_ubs: '',
      },
      loading: false,
      loadingSelectCidades: false,
      errorMsg: '',
      dadosExportarBpaC: [],
      dadosExportarBpaI: [],
      dadosBpaC: [],
      dadosBpaI: [],
      typeOptions: [
        {
          label: 'Exportar no BPA-C',
          value: 'bpac',
          description:
            'Recomendado para manter o comportamento padrão do sistema.',
        },
        {
          label: 'Exportar no BPA-I',
          value: 'bpai',
          description:
            'Use quando o município ou processo exigir que esses procedimentos sejam exportados como individualizados.',
        },
        // {
        //   label: 'BPA C ou BPA I',
        //   value: 'bpac-ou-bpai',
        // },
      ],
      loadingSelectEstabelecimento: false,
      estabelecimentos: [],
      loadingImportarSigtap: false,
      exportacaoLiberada: false,
      sigtapObrigatorio: false,
    }
  },
  computed: {
    maskNumbers() {
      return Masks['number']
    },
    maskCnpj() {
      return Masks['cnpj']
    },
    maskVersaoSistema() {
      return Masks['versaoSistema']
    },
  },
  watch: {
    // 'form.cidade'(novo) {
    //   this.form.rspSigla = novo.co_ibge.slice(0, 6)
    // },
  },
  created() {
    this.carregarSelectEstabelecimentos()
    this.verificarSigtap()
  },
  methods: {
    /**
     * Manipula ao selecionar um estado
     *
     * @param {Object} event
     */
    onChangeEstados(event) {
      this.loadingSelectCidades = true
      let estado = event.uf

      if (estado == null) {
        return
      }

      this.$apiPublic
        .get('/cidades-por-uf/' + estado)
        .then((response) => {
          this.cidades = response.data
        })
        .catch(function (error) {
          console.log(error)
        })
        .finally(() => {
          this.loadingSelectCidades = false
        })
    },

    /**
     * Verifica se o SIGTAP precisa ser importado antes da exportação.
     *
     * @returns {Promise<void>}
     */
    async verificarSigtap() {
      try {
        const response = await this.$api.get(
          `/app/bpa/${this.$store.state.cod_ibge}/verificar-sigtap`
        )

        const obrigatorio = Number(response?.data.update_tp_registro) === 1

        this.sigtapObrigatorio = obrigatorio

        // Se não for obrigatório, já libera exportação
        this.exportacaoLiberada = !obrigatorio
      } catch (error) {
        console.log(error)

        // Em caso de erro, mantém bloqueado
        this.sigtapObrigatorio = true
        this.exportacaoLiberada = false
      }
    },

    /**
     * Envia os arquivos SIGTAP para importação.
     *
     * @param {Object} arquivos Arquivos selecionados no modal
     * @returns {Promise<void>}
     */
    async importarSigtap(arquivos) {
      try {
        this.errorMsg = ''
        this.exportacaoLiberada = false
        this.loadingImportarSigtap = true

        const formData = new FormData()
        formData.append('co_ibge', this.$store.state.cod_ibge)
        formData.append(
          'rl_procedimento_registro',
          arquivos.rl_procedimento_registro
        )
        formData.append(
          'rl_procedimento_detalhe',
          arquivos.rl_procedimento_detalhe
        )

        const response = await this.$api.post(
          '/app/bpa/importar-sigtap',
          formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          }
        )

        if (response?.data?.success === true) {
          this.$toast?.success?.(
            response?.data?.message || 'SIGTAP importado com sucesso.'
          )

          this.$refs.modalImportarSigtap.fechar()

          await this.verificarSigtap()

          return
        }

        this.exportacaoLiberada = false
        this.$toast?.error?.(
          response?.data?.message || 'Não foi possível importar o SIGTAP.'
        )
      } catch (error) {
        console.log(error)
        this.exportacaoLiberada = false
        this.$toast?.error?.('Erro ao importar SIGTAP. Tente novamente.')
      } finally {
        this.loadingImportarSigtap = false
      }
    },

    /**
     * Exporta os dados
     */
    async exportar() {
      try {
        const isValid = await this.$refs.form.validate()
        if (!isValid) {
          return false
        }

        if (this.sigtapObrigatorio && !this.exportacaoLiberada) {
          this.$toast?.error?.('Importe o SIGTAP antes de exportar.')
          return
        }

        this.errorMsg = ''
        this.loading = true

        const resp = await this.$api.post(`/app/bpa/exportar`, {
          co_ibge: this.$store.state.cod_ibge,
          mes_ano: `${this.form.mes.value}-${this.form.ano}`,
          tipo: this.form.tipo,
          co_ubs: this.form.co_ubs.co_ubs,
        })

        this.dadosBpaC = resp.data.bpac
        this.dadosBpaI = resp.data.bpai

        let dadosOriginais = []
        let linhasBPAC = []
        let linhasBPAI = []
        let dadosParaExportar = []

        if (this.form.tipo == 'bpac') {
          linhasBPAC = this.montarLinhasBPAC(this.dadosBpaC)
          linhasBPAI = this.montarLinhasBPAI(this.dadosBpaI)
        }
        if (this.form.tipo == 'bpai') {
          linhasBPAI = this.montarLinhasBPAI(this.dadosBpaI)
          linhasBPAC = this.montarLinhasBPAC(this.dadosBpaC)
        }

        dadosOriginais = [...this.dadosBpaC, ...this.dadosBpaI]
        dadosParaExportar = [...linhasBPAC, ...linhasBPAI]

        const mvm = `${this.form.ano}${this.form.mes.value}`

        // Domínio
        const smtVrfCalc = this.calcularSmtVrf(dadosOriginais)

        const maxFolhaBPAC = (linhasBPAC || []).reduce((acc, linha) => {
          const v = parseInt(linha.slice(21, 24), 10) || 0
          return Math.max(acc, v)
        }, 0)

        const maxFolhaBPAI = (linhasBPAI || []).reduce((acc, linha) => {
          const v = parseInt(linha.slice(44, 47), 10) || 0
          return Math.max(acc, v)
        }, 0)

        const totalFolhas = maxFolhaBPAC + maxFolhaBPAI + 1 // +1 do cabeçalho

        const header = this.gerarCabecalhoBPA({
          mvm,
          totalLinhas: dadosParaExportar.length + 1, // +1 da linha do cabeçalho
          totalFolhas: totalFolhas,
          smtVrf: smtVrfCalc,
        })

        const conteudo = [header, ...dadosParaExportar].join('\r\n')

        const blob = new Blob([conteudo], {
          type: 'text/plain;charset=windows-1252',
        })
        const monthSuffixMap = {
          '01': 'JAN',
          '02': 'FEV',
          '03': 'MAR',
          '04': 'ABR',
          '05': 'MAI',
          '06': 'JUN',
          '07': 'JUL',
          '08': 'AGO',
          '09': 'SET',
          10: 'OUT',
          11: 'NOV',
          12: 'DEZ',
        }
        const mesValue = this.form.mes?.value
        const extMes = monthSuffixMap[mesValue]

        const cnes = this.form.co_ubs.no_unidade_saude.split(' ')[0]
        const nomeArquivo = `BPA_${cnes}.${extMes}`

        const a = document.createElement('a')
        a.href = URL.createObjectURL(blob)
        a.download = nomeArquivo
        a.click()
        URL.revokeObjectURL(a.href)
      } catch (err) {
        console.log(err)
        this.errorMsg = 'Erro ao exportar o arquivo. Tente novamente.'
      } finally {
        this.loading = false
      }
    },

    /**
     * Aplica as regras para um campo
     *
     * @param value
     * @param length
     * @param type
     * @param defaultFill
     *
     * @returns {String}
     */
    fitField(value, length, type = 'ALFA', defaultFill = 'Brancos') {
      let v = (value ?? '').toString()

      // corta se ultrapassar
      if (v.length > length) v = v.slice(0, length)

      // Regras de preenchimento oficial BPA-I:
      const isNumeric = type === 'NUM'
      const fillWithZeros = isNumeric && defaultFill === 'Zeros'

      if (fillWithZeros) {
        // número obrigatório - zeros à esquerda
        return v.padStart(length, '0')
      }

      if (isNumeric && defaultFill === 'Brancos') {
        // número opcional - espaços à esquerda
        return v.padStart(length, ' ')
      }

      // ALFA - espaços à direita
      return v.padEnd(length, ' ')
    },

    /**
     * Gera o cabeçalho do BPA
     */
    gerarCabecalhoBPA({ mvm, totalLinhas, totalFolhas = 1, smtVrf }) {
      const L = [
        // 1) cbc-hdr (01) - Indicador de linha do Header
        this.fitField('01', 2, 'NUM', 'Zeros'),

        // 2) tag "#BPA#" - Indicador de início do cabeçalho
        this.fitField('#BPA#', 5, 'ALFA', 'Brancos'),

        // 3) cbc-mvm AAAAMM (NUM/Brancos) - Ano e mês de Processamento da produção
        this.fitField(mvm, 6, 'NUM', 'Brancos'),

        // 4) cbc-lin (NUM/Zeros) - Número de linhas do BPA gravadas.
        this.fitField(String(totalLinhas), 6, 'NUM', 'Zeros'),

        // 5) cbc-flh (NUM/Zeros) - Quantidades de folhas de BPA gravadas.
        this.fitField(String(totalFolhas), 6, 'NUM', 'Zeros'),

        // 6) cbc-smt-vrf (NUM/Zeros) - Campo de controle.DOMÍNIO [1111..2221]
        this.fitField(smtVrf, 4, 'NUM', 'Zeros'),

        // 7) cbc-rsp (ALFA/Brancos) - Nome do órgão de origem responsável pela informação.
        this.fitField(this.noAccent(this.form.rspNome), 30, 'ALFA', 'Brancos'),

        // 8) cbc-sgl (ALFA/Brancos) - Sigla do órgão de origem responsável pela digitação
        this.fitField(this.noAccent(this.form.rspSigla), 6, 'ALFA', 'Brancos'),

        // 9) cbc-cgccpf (NUM/Zeros) - CGC/CPF do prestador ou do órgão público responsável pela informação, conforme cadastro na Receita Federal.
        this.fitField(this.onlyDigits(this.form.rspCgcCpf), 14, 'NUM', 'Zeros'),

        // 10) cbc-dst (ALFA/Brancos) - Nome do órgão de saúde destino do arquivo
        this.fitField(
          this.noAccent(this.form.destinoNome),
          40,
          'ALFA',
          'Brancos'
        ),

        // 11) cbc-dst-in (ALFA/Brancos) -> 'M' ou 'E' - Indicador do órgão
        this.fitField(
          (this.form.destinoTipo || 'M').toString().toUpperCase(),
          1,
          'ALFA',
          'Brancos'
        ),

        // 12) cbc_versao (ALFA/Brancos) - Versão do sistema
        this.fitField(this.noAccent(this.form.versao), 10, 'ALFA', 'Brancos'),

        // 13) fim
        // this.fitField('', 2, 'ALFA', 'Brancos'),
      ]

      return L.join('')
    },

    /**
     * Monta as linhas do BPA C
     *
     * @param {Array} lista
     *
     * @returns {Array}
     */
    montarLinhasBPAC(lista) {
      if (!Array.isArray(lista) || lista.length === 0) return []

      // Layout do BPA-C (cada item vira exatamente 1 linha "02...")
      const layoutC = [
        {
          // 1) Identificador do registro BPA-C
          nome: 'prd-ident',
          length: 2,
          type: 'NUM',
          fill: 'Zeros',
          formatter: () => '02',
        },
        {
          // 2) CNES
          nome: 'prd-cnes',
          length: 7,
          type: 'NUM',
          fill: 'Zeros',
          formatter: (it) => this.onlyDigits(it?.cnes),
        },
        {
          // 3) Competência AAAAMM
          nome: 'prd-cmp',
          length: 6,
          type: 'NUM',
          fill: 'Brancos',
          formatter: (it) => `${this.form.ano}${this.form.mes.value}`,
        },
        {
          // 4) CBO
          nome: 'prd-cbo',
          length: 6,
          type: 'ALFA',
          fill: 'Brancos',
          formatter: (it) => (it?.cbo || '').toString().trim(),
        },
        {
          // 5) Folha
          nome: 'prd-flh',
          length: 3,
          type: 'NUM',
          fill: 'Zeros',
          formatter: (it) => {
            let seq_global = Number(it.seq_global) || 0
            let folha = Math.floor((seq_global - 1) / 20) + 1
            return folha
          },
        },
        {
          // 6) Sequência
          nome: 'prd-seq',
          length: 2,
          type: 'NUM',
          fill: 'Zeros',
          formatter: (it) => {
            let seq_global = Number(it.seq_global) || 0
            let sequencia = ((seq_global - 1) % 20) + 1
            return sequencia
          },
        },
        {
          // 7) Procedimento (PA)
          nome: 'prd-pa',
          length: 10,
          type: 'NUM',
          fill: 'Zeros',
          formatter: (it) => this.onlyDigits(it?.procedimento),
        },
        {
          // 8) Idade (0..130)
          nome: 'prd-idade',
          length: 3,
          type: 'NUM',
          fill: 'Zeros',
          formatter: (it) => {
            // 1) tenta usar idade vinda do banco
            const idadeRaw = it?.idade

            // aceita "25", 25, " 25 ", etc
            const idadeNum =
              idadeRaw === null || idadeRaw === undefined || idadeRaw === ''
                ? NaN
                : Number(idadeRaw)

            const idadeFinal = Number.isFinite(idadeNum)
              ? idadeNum
              : this.calcIdadeNumber(it?.dt_nascimento)

            return String(Math.max(0, Math.min(130, idadeFinal)))
          },
        },
        {
          // 9) Quantidade
          nome: 'prd-qt',
          length: 6,
          type: 'NUM',
          fill: 'Zeros',
          formatter: (it) => String(it?.quantidade ?? 1),
        },
        {
          // 10) Origem
          nome: 'prd-org',
          length: 3,
          type: 'ALFA',
          fill: 'Brancos',
          formatter: () => 'BPA',
        },
        // {
        //   // 11) Fim
        //   nome: 'prd-fim',
        //   length: 2,
        //   type: 'ALFA',
        //   fill: 'Brancos',
        //   formatter: () => '',
        // },
      ]

      const linhas = []
      for (const it of lista) {
        // validações mínimas para evitar linhas inválidas
        // const cnes = this.onlyDigits(it?.cnes)
        // const pa = this.onlyDigits(it?.procedimento)
        // if (!cnes || !pa) continue

        const partes = layoutC.map((def) =>
          this.fitField(def.formatter(it) ?? '', def.length, def.type, def.fill)
        )
        linhas.push(partes.join(''))
      }

      return linhas
    },

    /**
     * Monta as linhas do BPA I
     *
     * @param {Array} lista
     *
     * @returns {Array}
     */
    montarLinhasBPAI(lista) {
      if (!Array.isArray(lista) || lista.length === 0) return []

      const layoutSET = [
        {
          // 1) Identificador do registro BPA-I
          nome: 'prd-ident',
          length: 2,
          type: 'NUM',
          fill: 'Zeros',
          formatter: () => '03',
        },
        {
          // 2) CNES
          nome: 'prd-cnes',
          length: 7,
          type: 'NUM',
          fill: 'Zeros',
          formatter: (it) => this.onlyDigits(it?.nu_cnes ?? it?.cnes ?? ''),
        },
        {
          // 3) Competência AAAAMM
          nome: 'prd-cmp',
          length: 6,
          type: 'NUM',
          fill: 'Brancos',
          formatter: (it) => `${this.form.ano}${this.form.mes.value}`,
        },
        {
          // 4) CNS do profissional
          nome: 'prd-cnsmed',
          length: 15,
          type: 'NUM',
          fill: 'Brancos',
          formatter: (it) => this.onlyDigits(it?.cns_prof || ''),
        },
        {
          // 5) CBO
          nome: 'prd-cbo',
          length: 6,
          type: 'ALFA',
          fill: 'Brancos',
          formatter: (it) => (it?.nu_cbo ?? it?.cbo ?? '').toString().trim(),
        },
        {
          // 6) Data do atendimento YYYYMMDD
          nome: 'prd-dtaten',
          length: 8,
          type: 'NUM',
          fill: 'Zeros',
          formatter: (it) => this.toYYYYMMDD(it?.dt_procedimento),
        },
        {
          // 7) Folha (se não usar, deixe "001")
          nome: 'prd-flh',
          length: 3,
          type: 'NUM',
          fill: 'Zeros',
          formatter: (it) => {
            let seq_global = Number(it.seq_global) || 0
            let folha = Math.floor((seq_global - 1) / 99) + 1
            return folha
          },
        },
        {
          // 8) Seq (se não usar, deixe "01")
          nome: 'prd-seq',
          length: 2,
          type: 'NUM',
          fill: 'Zeros',
          formatter: (it) => {
            let seq_global = Number(it.seq_global) || 0
            let sequencia = ((seq_global - 1) % 99) + 1
            return sequencia
          },
        },
        {
          // 9) Procedimento (PA)
          nome: 'prd-pa',
          length: 10,
          type: 'NUM',
          fill: 'Brancos',
          formatter: (it) => this.onlyDigits(it?.procedimento),
        },
        {
          // 10) CNS do paciente
          nome: 'prd-cnspac',
          length: 15,
          type: 'NUM',
          fill: 'Brancos',
          formatter: (it) => {
            if (it?.nu_cns != null && it?.nu_cpf_cidadao == null) {
              return this.onlyDigits(it?.nu_cns)
            }
            return this.onlyDigits('')
          },
        },
        {
          // 11) Sexo
          nome: 'prd-sexo',
          length: 1,
          type: 'ALFA',
          fill: 'Brancos',
          formatter: (it) => this.mapSexo(it?.sexo),
        },
        {
          // 12) IBGE do município do prestador
          nome: 'prd-ibge',
          length: 6,
          type: 'ALFA',
          fill: 'Brancos',
          formatter: () =>
            this.onlyDigits(this.form.cidade.co_ibge.slice(0, 6)),
        },
        {
          // 13) CID (4 chars)
          nome: 'prd-cid',
          length: 4,
          type: 'ALFA',
          fill: 'Brancos',
          formatter: (it) => it?.cid || '',
        },
        {
          // 14) Idade (0..130) com 3 dígitos
          nome: 'prd-idade',
          length: 3,
          type: 'NUM',
          fill: 'Zeros',
          formatter: (it) => String(Math.max(0, Math.min(130, it?.idade))),
        },
        {
          // 15) Quantidade
          nome: 'prd-qt',
          length: 6,
          type: 'NUM',
          fill: 'Zeros',
          formatter: (it) => String(it?.quantidade ?? 1),
        },
        {
          // 16) Caráter do atendimento
          nome: 'prd-caten',
          length: 2,
          type: 'NUM',
          fill: 'Brancos',
          formatter: (it) => it?.carat_atend || '01',
        },
        {
          // 17) Nº Autorização
          nome: 'prd-naut',
          length: 13,
          type: 'NUM',
          fill: 'Brancos',
          formatter: () => '',
        },
        {
          // 18) Origem
          nome: 'prd-org',
          length: 3,
          type: 'ALFA',
          fill: 'Brancos',
          formatter: () => 'BPA',
        },
        {
          // 19) Nome do paciente
          nome: 'prd-nmpac',
          length: 30,
          type: 'ALFA',
          fill: 'Brancos',
          formatter: (it) => this.noAccent(it?.no_cidadao),
        },
        {
          // 20) Data de nascimento YYYYMMDD
          nome: 'prd-dtnasc',
          length: 8,
          type: 'NUM',
          fill: 'Zeros',
          formatter: (it) => this.toYYYYMMDD(it?.dt_nascimento),
        },
        {
          // 21) Raça/Cor
          nome: 'prd-raca',
          length: 2,
          type: 'NUM',
          fill: 'Brancos',
          formatter: (it) => this.mapRaca(it?.id_raca_cor),
        },
        {
          // 22) Etnia
          nome: 'prd-etnia',
          length: 4,
          type: 'NUM',
          fill: 'Brancos',
          formatter: (it) => this.onlyDigits(it?.etnia || ''),
        },
        // 23) Nacionalidade do paciente
        {
          nome: 'prd-nac',
          length: 3,
          type: 'NUM',
          fill: 'Brancos',
          formatter: (it) => this.onlyDigits(it.nacionalidade || ''),
        },
        // 24) Código do Serviço
        {
          nome: 'prd_srv',
          length: 3,
          type: 'NUM',
          fill: 'Brancos',
          formatter: (it) => this.onlyDigits(it.servico || ''),
        },
        // 25) Código Classificação
        {
          nome: 'prd_clf',
          length: 3,
          type: 'NUM',
          fill: 'Brancos',
          formatter: (it) => this.onlyDigits(it.classificacao || ''),
        },
        // 26) Código Sequência da Equipe
        {
          nome: 'prd_equipe_Seq',
          length: 8,
          type: 'NUM',
          fill: 'Brancos',
          formatter: (it) => this.onlyDigits(it.equipe_seq || ''),
        },
        // 27) Código Área da Equipe
        {
          nome: 'prd_equipe_Area',
          length: 4,
          type: 'NUM',
          fill: 'Brancos',
          formatter: (it) => this.onlyDigits(it.equipe_area || ''),
        },
        // 28) CNPJ do prestador
        {
          nome: 'prd_cnpj',
          length: 14,
          type: 'NUM',
          fill: 'Brancos',
          formatter: (it) => this.onlyDigits(it.cnpj_prestador || ''),
        },
        // 29) CEP paciente
        {
          nome: 'prd_cep_pcnte',
          length: 8,
          type: 'NUM',
          fill: 'Brancos',
          formatter: (it) => this.onlyDigits(this.getEndereco(it).ds_cep || ''),
        },
        // 30) Tipo Logradouro paciente
        {
          nome: 'prd_lograd_pcnte',
          length: 3,
          type: 'NUM',
          fill: 'Brancos',
          formatter: (it) =>
            this.mapTipoLogradouro(this.getEndereco(it).no_tipo_logradouro),
        },
        // 31) Endereço paciente
        {
          nome: 'prd_end_pcnte',
          length: 30,
          type: 'ALFA',
          fill: 'Brancos',
          formatter: (it) =>
            this.noAccent(this.getEndereco(it).ds_logradouro || ''),
        },
        // 32) Complemento
        {
          nome: 'prd_compl_pcnte',
          length: 10,
          type: 'ALFA',
          fill: 'Brancos',
          formatter: (it) =>
            this.noAccent(this.getEndereco(it).ds_complemento || ''),
        },
        // 33) Número da residência
        {
          nome: 'prd_num_pcnte',
          length: 5,
          type: 'ALFA',
          fill: 'Brancos',
          formatter: (it) => {
            const num = (this.getEndereco(it).nu_numero || '').toString()
            if (!num || num.toUpperCase() === 'S/N') return 'SN'
            return num
          },
        },
        // 34) Bairro
        {
          nome: 'prd_bairro_pcnte',
          length: 30,
          type: 'ALFA',
          fill: 'Brancos',
          formatter: (it) =>
            this.noAccent(this.getEndereco(it).no_bairro || ''),
        },
        // 35) Telefone
        {
          nome: 'prd_ddtel_pcnte',
          length: 11,
          type: 'NUM',
          fill: 'Brancos',
          // formatter: (it) => this.bestPhone(this.getEndereco(it)),
          formatter: (it) => '',
        },
        // 36) Email
        {
          nome: 'prd_email_pcnte',
          length: 40,
          type: 'ALFA',
          fill: 'Brancos',
          // formatter: (it) => this.noAccent(it.email || ''),
          formatter: (it) => '',
        },
        // 37) INE da equipe
        {
          nome: 'prd_ine',
          length: 10,
          type: 'NUM',
          fill: 'Brancos',
          formatter: (it) => this.onlyDigits(it.nu_ine || ''),
        },
        {
          // 38) CPF do paciente
          nome: 'prd-cpf',
          length: 11,
          type: 'NUM',
          fill: 'Brancos',
          formatter: (it) => this.onlyDigits(it?.nu_cpf_cidadao || ''),
        },
        //  {
        //   // 38) Fim
        //   nome: 'prd-fim',
        //   length: 2,
        //   type: 'ALFA',
        //   fill: 'Brancos',
        //   formatter: () => '',
        // },
      ]

      const linhas = []

      for (const it of lista) {
        // validações mínimas
        // const cnes = this.onlyDigits(it?.nu_cnes)
        // const cmp = this.toYYYYMM(it?.mes)
        // const pa = this.onlyDigits(it?.procedimento)
        if (it.nu_cpf_cidadao == null && it.nu_cns == null) continue

        const partes = layoutSET.map((def) =>
          this.fitField(def.formatter(it) ?? '', def.length, def.type, def.fill)
        )
        linhas.push(partes.join(''))
      }

      return linhas
    },

    /**
     * Carrega os estabelecimentos de saúde
     */
    async carregarSelectEstabelecimentos() {
      try {
        this.loadingSelectEstabelecimento = true
        let response = await this.$api.get(
          `/app/relatorio-atendimentos/${this.$store.state.cod_ibge}/unidades-de-saude`
        )
        if (response) {
          this.estabelecimentos = response.data
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.loadingSelectEstabelecimento = false
      }
    },

    /**
     * Converte uma data para o formato YYYYMMDD.
     * Aceita "YYYY-MM-DD", "DD/MM/YYYY" ou qualquer data válida.
     * @param {String|Date} s Data de entrada
     * @returns {String} Data no formato YYYYMMDD
     */
    toYYYYMMDD(s) {
      if (!s) return ''.padStart(8, '0')
      // aceita "YYYY-MM-DD" ou "DD/MM/YYYY"
      const t = s.toString().trim()
      if (/^\d{4}-\d{2}-\d{2}$/.test(t)) {
        return t.replace(/-/g, '')
      }
      if (/^\d{2}\/\d{2}\/\d{4}$/.test(t)) {
        const [dd, mm, yyyy] = t.split('/')
        return `${yyyy}${mm}${dd}`
      }
      // fallback: tenta Date
      const d = new Date(t)
      if (!isNaN(d.getTime())) {
        const yyyy = String(d.getFullYear())
        const mm = String(d.getMonth() + 1).padStart(2, '0')
        const dd = String(d.getDate()).padStart(2, '0')
        return `${yyyy}${mm}${dd}`
      }
      return ''.padStart(8, '0')
    },

    /**
     * Converte uma referência de mês para o formato YYYYMM.
     * Aceita "MM/YYYY" ou "YYYY-MM-DD".
     * @param {String} mesStr Referência do mês
     * @returns {String} Data no formato YYYYMM
     */
    toYYYYMM(mesStr) {
      // entrada: "10/2025" -> "202510"
      if (!mesStr) return ''.padStart(6, '0')
      const t = mesStr.toString().trim()
      if (/^\d{2}\/\d{4}$/.test(t)) {
        const [mm, yyyy] = t.split('/')
        return `${yyyy}${mm}`
      }
      // fallback: tenta "YYYY-MM-DD"
      if (/^\d{4}-\d{2}-\d{2}$/.test(t)) {
        const [yyyy, mm] = t.split('-')
        return `${yyyy}${mm}`
      }
      return ''.padStart(6, '0')
    },

    /**
     * Remove todos os caracteres não numéricos de uma string.
     * @param {String} s Valor de entrada
     * @returns {String} String contendo apenas números
     */
    onlyDigits(s) {
      return (s ?? '').toString().replace(/\D+/g, '')
    },

    /**
     * Remove acentos de um texto.
     * @param {String} s Texto de entrada
     * @returns {String} Texto sem acentuação
     */
    noAccent(s) {
      const v = (s ?? '').toString()
      // remove acentos
      return v.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
    },

    /**
     * Normaliza o sexo para 'M' ou 'F'.
     * Aceita valores como "M", "F", "Masculino" ou "Feminino".
     * @param {String} s Valor do sexo
     * @returns {String} Sexo normalizado
     */
    mapSexo(s) {
      const v = (s ?? '').toString().trim().toUpperCase()
      // aceita 'M', 'F', 'MASCULINO', 'FEMININO'
      if (v.startsWith('M')) return 'M'
      if (v.startsWith('F')) return 'F'
      return ''
    },

    /**
     * Retorna o endereço do cidadão a partir do JSON armazenado.
     * @param {Object} item Registro do cidadão
     * @returns {Object} Objeto de endereço
     */
    getEndereco(item) {
      // contato_endereco chega como string JSON
      try {
        const raw = item?.contato_endereco
        if (!raw) return {}
        return JSON.parse(raw)
      } catch (e) {
        return {}
      }
    },

    /**
     * Retorna o melhor telefone disponível do endereço.
     * Prioriza celular e, caso não exista, utiliza telefone de contato.
     * @param {Object} end Objeto de endereço
     * @returns {String} Número de telefone
     */
    bestPhone(end) {
      // tenta celular, depois contato
      const c1 = this.onlyDigits(end?.nu_telefone_celular || '')
      if (c1) return c1
      const c2 = this.onlyDigits(end?.nu_telefone_contato || '')
      return c2 || ''
    },

    /**
     * Calcula a idade numérica com base na data de nascimento.
     * @param {String} dtNasc Data de nascimento
     * @returns {Number} Idade em anos
     */
    calcIdadeNumber(dtNasc) {
      // Converte para YYYYMMDD (aceita "YYYY-MM-DD" ou "DD/MM/YYYY")
      const ymdN = this.toYYYYMMDD(dtNasc)
      if (!/^\d{8}$/.test(ymdN)) return 0

      // Data de hoje (no fuso do navegador)
      const now = new Date()
      const ymdR = [
        String(now.getFullYear()),
        String(now.getMonth() + 1).padStart(2, '0'),
        String(now.getDate()).padStart(2, '0'),
      ].join('')

      const yN = +ymdN.slice(0, 4)
      const mN = +ymdN.slice(4, 6)
      const dN = +ymdN.slice(6, 8)

      const yR = +ymdR.slice(0, 4)
      const mR = +ymdR.slice(4, 6)
      const dR = +ymdR.slice(6, 8)

      let idade = yR - yN
      if (mR < mN || (mR === mN && dR < dN)) idade--

      return Math.max(0, Math.min(130, idade))
    },

    /**
     * Calcula o valor SMT_VRF com base na lista de procedimentos.
     * @param {Array} lista Lista de procedimentos
     * @returns {String} Código de verificação SMT
     */
    calcularSmtVrf(lista) {
      // 1) Somar (código do procedimento + quantidade) para todos os itens
      let soma = 0n

      for (const it of lista || []) {
        // procedimento (numérico)
        const paStr = this.onlyDigits(it?.procedimento)
        const pa = paStr ? BigInt(paStr) : 0n

        const qtdRaw = it?.quantidade ?? 1
        const qtdStr = this.onlyDigits(qtdRaw)
        const qtd = qtdStr ? BigInt(qtdStr) : 0n

        soma += pa + qtd
      }

      // 2) Resto da divisão por 1111
      const resto = soma % 1111n

      // 3) Somar 1111 ao resto
      const smt = 1111n + resto // [1111..2221]

      return smt.toString().padStart(4, '0')
    },

    /**
     * Normaliza o código de raça/cor para o padrão do sistema.
     * @param {String|Number} raca Valor informado
     * @returns {String} Código de raça normalizado
     */
    mapRaca(raca) {
      const v = (raca ?? '').toString().trim()

      // tenta preservar caso já venha "01", "02", etc
      const num = this.onlyDigits(v)

      if (['01', '1'].includes(num)) return '01'
      if (['02', '2'].includes(num)) return '02'
      if (['03', '3'].includes(num)) return '03'
      if (['04', '4'].includes(num)) return '04'
      if (['05', '5'].includes(num)) return '05'

      // Sem informação / inválido / vazio -> 99
      return '99'
    },

    /**
     * Mapeia o tipo de logradouro para o código correspondente.
     * @param {String} no_tipo_logradouro Nome do tipo de logradouro
     * @returns {String} Código do tipo de logradouro
     */
    mapTipoLogradouro(no_tipo_logradouro) {
      if (!no_tipo_logradouro) return ''
      const key = normalizeTexto(no_tipo_logradouro)
      return MAP_TIPO_LOGRADOURO.get(key) ?? ''
    },
  },
}
</script>

<style scoped lang="scss">
#exportar-bpa {
  .container-inputs > div {
    margin-top: 15px;
  }
  .tipo-export__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    margin-bottom: 10px;
  }

  .tipo-export__title {
    color: #000;
  }

  .tipo-export__badge {
    font-size: 12px;
    padding: 6px 10px;
    border-radius: 999px;
    color: #000;
    background: rgba(102, 126, 234, 0.12);
    border: 1px solid rgba(102, 126, 234, 0.35);
    white-space: nowrap;
  }

  .tipo-export__info {
    background: rgba(102, 126, 234, 0.1);
    border: 1px solid rgba(102, 126, 234, 0.28);
    border-radius: 14px;
    padding: 14px 16px;
    margin-bottom: 12px;
    color: #000;
  }

  .tipo-export__info-title {
    font-weight: 700;
    color: #000;
    margin-bottom: 6px;
  }

  .tipo-export__info-text {
    line-height: 1.35;
    color: 000;

    b {
      color: #000;
      font-weight: 700;
    }
  }

  .tipo-export__group {
    display: flex;
    gap: 12px;
  }

  .tipo-export__option {
    display: flex;
    flex: 1;
    align-items: flex-start;
    gap: 12px;
    padding: 14px 16px;
    border-radius: 14px;
    cursor: pointer;
    user-select: none;

    background: rgba(0, 0, 0, 0.12);
    border: 1px solid rgba(255, 255, 255, 0.1);
    color: #000;

    transition: transform 0.05s ease, border-color 0.15s ease,
      background-color 0.15s ease;
  }

  .tipo-export__option:hover {
    border-color: rgba(255, 255, 255, 0.18);
    background: rgba(0, 0, 0, 0.16);
  }

  .tipo-export__option.is-active {
    border-color: rgba(102, 126, 234, 0.7);
    background: rgba(102, 126, 234, 0.12);
  }

  .tipo-export__radio {
    margin-top: 2px;
    margin-right: 0;
    .custom-control {
      min-height: auto;
    }
  }

  .tipo-export__option-title {
    font-weight: 700;
    color: #000;
    margin-bottom: 2px;
  }

  .tipo-export__option-desc {
    font-size: 13px;
    line-height: 1.25;
    color: #000;
  }

  .bpa-fieldset {
    border: 1px solid rgba(0, 0, 0, 0.12);
    border-radius: 14px;
    padding: 14px 16px 16px;
    margin-top: 10px;
    background: rgba(0, 0, 0, 0.03);
    min-inline-size: auto;
  }

  .bpa-fieldset__legend {
    font-weight: 700;
    font-size: 13px;
    padding: 0 8px;
    margin: 0;
    width: auto;
    color: #000;
    border-radius: 999px;
  }

  .btn-actions {
    .btn-primary:disabled,
    .btn-primary.disabled {
      background: #adb5bd !important;
      border-color: #adb5bd !important;
      color: #495057 !important;
      cursor: not-allowed;
      opacity: 1;
    }
  }
}
</style>
